module.exports = "<button class=\"btn btn-default\" type=\"button\"\n        ng-click=\"$ctrl.goBack()\">Cancel\n</button>"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/directives/jf-cancel-back-button/jf-cancel-back-button.view.html
// module id = 477
// module chunks = 7